import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Copy } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const BLOCKS = [["textos", "Textos"], ["titulos", "Títulos"], ["ctas", "Chamadas para ação"], ["ideias_imagem", "Ideias de imagem"], ["ideias_video", "Ideias de vídeo"], ["configuracao", "Configuração recomendada"], ["alertas", "Atenção"]];

const Block = ({ title, items }) => (
  <div className="surface p-4">
    <p className="eyebrow mb-2">{title}</p>
    <ul className="space-y-1.5">{items.map((t) => <li key={t} className="text-sm flex gap-2 group"><span className="flex-1">{t}</span>
      <button onClick={() => { navigator.clipboard.writeText(t); toast.success("Copiado"); }} className="opacity-40 group-hover:opacity-100" aria-label="Copiar"><Copy className="h-3.5 w-3.5" /></button></li>)}</ul>
  </div>
);

export function ChannelAssistant({ channel, label }) {
  const [f, setF] = useState({ business: "", goal: "", audience: "", offer: "", budget: "" });
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const run = async () => {
    setBusy(true);
    try { setRes((await api.post("/channels/ai", { channel, ...f })).data.result); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="space-y-3" data-testid={`channel-ai-${channel}`}>
      <div className="surface p-4 space-y-3">
        <p className="font-semibold flex items-center gap-2"><Sparkles className="h-4 w-4 text-primary" />Assistente de IA para {label}</p>
        <Textarea placeholder="Descreva o negócio, produto ou serviço" value={f.business} onChange={set("business")} rows={2} data-testid="channel-ai-business" />
        <div className="grid sm:grid-cols-4 gap-2">
          <Input placeholder="Objetivo" value={f.goal} onChange={set("goal")} data-testid="channel-ai-goal" />
          <Input placeholder="Público" value={f.audience} onChange={set("audience")} data-testid="channel-ai-audience" />
          <Input placeholder="Oferta" value={f.offer} onChange={set("offer")} data-testid="channel-ai-offer" />
          <Input placeholder="Orçamento/dia" value={f.budget} onChange={set("budget")} data-testid="channel-ai-budget" />
        </div>
        <div className="flex items-center gap-3"><Button onClick={run} disabled={busy || f.business.length < 3} className="rounded-full" data-testid="channel-ai-run">{busy ? "Gerando..." : "Gerar sugestões"}</Button>
          <span className="text-xs text-muted-foreground">Consome créditos do seu plano. Sugestões não são publicadas automaticamente.</span></div>
      </div>
      {res && (
        <div className="space-y-3" data-testid="channel-ai-result">
          <div className="surface p-4"><p className="eyebrow mb-1">Estratégia</p><p className="text-sm">{res.estrategia}</p>{res.publico_sugerido && <p className="text-sm text-muted-foreground mt-2"><b>Público:</b> {res.publico_sugerido}</p>}</div>
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">{BLOCKS.filter(([k]) => res[k]?.length).map(([k, t]) => <Block key={k} title={t} items={res[k]} />)}</div>
        </div>
      )}
    </section>
  );
}
